import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { RpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { injectRpServiceId } from "@utils/parameter-injector";

type UpdateVerificationServiceDetailsRequestResponse = {
    transferObject: RpServiceConfiguration;
};

export const updateVerificationServiceDetailsRequest = async (
    rpServiceId: string,
    body: RpServiceConfiguration
): Promise<GenericNetworkResponse<UpdateVerificationServiceDetailsRequestResponse>> => {
    const route = injectRpServiceId(
        apiRoutes.serviceConfiguration.rpServiceConfig.axnAdmin.rpService,
        rpServiceId
    );
    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};